var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./components/footer.njk"] = require( "./components/footer.njk" );
dependencies["./components/modals.njk"] = require( "./components/modals.njk" );
dependencies["./components/svg-sprite-global.njk"] = require( "./components/svg-sprite-global.njk" );
dependencies["./components/header.njk"] = require( "./components/header.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/layout.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<!-- INCLUDED PARTIALS -->\r\n";
env.getTemplate("./components/footer.njk", false, "src/views/layout.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("footer", t_1);
output += "\r\n";
env.getTemplate("./components/modals.njk", false, "src/views/layout.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(context.getVariables(), frame, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("modals", t_4);
output += "\r\n\r\n<!DOCTYPE html>\r\n<html lang=\"en\">\r\n\r\n    <head>\r\n        <!-- OneTrust Cookies Consent Notice start for listmypractice.com -->\r\n        <script src=\"https://cdn.cookielaw.org/scripttemplates/otSDKStub.js\" data-language=\"en\" type=\"text/javascript\" charset=\"UTF-8\" data-domain-script=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "oneTrustToken"), env.opts.autoescape);
output += "\" ></script>\r\n        <script type=\"text/javascript\">\r\n            function OptanonWrapper() { }\r\n        </script>\r\n        <!-- OneTrust Cookies Consent Notice end for listmypractice.com -->\r\n        <meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\"/>\r\n        <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\r\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\r\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("robots"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
output += "\r\n        <title>";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_title"))(env, context, frame, runtime, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
output += t_9;
output += "</title>\r\n        <meta name=\"description\" content=\"";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_description"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\">\r\n        <link rel=\"icon\" href=\"/assets/img/Favicon.png\" type=\"image/png\">\r\n        <link href=\"/main.css?cache=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "__webpack__")),"hash"), env.opts.autoescape);
output += "\" rel=\"stylesheet\" type=\"text/css\">\r\n    </head>\r\n\r\n    <body class=\"";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
output += t_13;
output += "\">\r\n        <!-- Google Tag Manager (noscript) -->\r\n        <noscript><iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-5TNNN9P\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe></noscript>\r\n    <!-- End Google Tag Manager (noscript) -->\r\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./components/svg-sprite-global.njk", false, "src/views/layout.njk", false, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
callback(null,t_15);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
callback(null,t_17);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./components/header.njk", false, "src/views/layout.njk", false, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
callback(null,t_19);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_22,t_21) {
if(t_22) { cb(t_22); return; }
callback(null,t_21);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n\r\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_24,t_23) {
if(t_24) { cb(t_24); return; }
output += t_23;
output += "\r\n\r\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("modals"))(env, context, frame, runtime, function(t_26,t_25) {
if(t_26) { cb(t_26); return; }
output += t_25;
output += "\r\n\r\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("footer"))(env, context, frame, runtime, function(t_28,t_27) {
if(t_28) { cb(t_28); return; }
output += t_27;
output += "\r\n\r\n        <div class=\"backdrop\"></div>\r\n        <script src=\"https://maps.googleapis.com/maps/api/js?key=AIzaSyBSUcW21CyQRVUZLzneHTyFbRJGwXyiV8g\"></script>\r\n        <script data-ot-ignore type=\"text/javascript\" src=\"/app.bundle.js?cache=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "__webpack__")),"hash"), env.opts.autoescape);
output += "\"></script>\r\n    </body>\r\n\r\n</html>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_robots(env, context, frame, runtime, cb) {
var lineno = 17;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_title(env, context, frame, runtime, cb) {
var lineno = 18;
var colno = 18;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_description(env, context, frame, runtime, cb) {
var lineno = 19;
var colno = 45;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 24;
var colno = 20;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 31;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_modals(env, context, frame, runtime, cb) {
var lineno = 33;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n            ";
output += runtime.suppressValue((lineno = 34, colno = 28, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "modals")),"render"), "modals[\"render\"]", context, [])), env.opts.autoescape);
output += "\r\n        ";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_footer(env, context, frame, runtime, cb) {
var lineno = 37;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n            ";
output += runtime.suppressValue((lineno = 38, colno = 28, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "footer")),"render"), "footer[\"render\"]", context, [])), env.opts.autoescape);
output += "\r\n        ";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_robots: b_robots,
b_meta_title: b_meta_title,
b_meta_description: b_meta_description,
b_body_class: b_body_class,
b_content: b_content,
b_modals: b_modals,
b_footer: b_footer,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/layout.njk"] , dependencies)